import type { PhotoURL } from '~/models/photo_url'

export const thumbSizes: number[] = [128, 256, 512, 1024, 2048]

export interface GalleryImage {
  file: string
  fileName: string // To identify /banners/[id]/fileName
  mimeType: string
  urls: PhotoURL
  status: boolean
}
interface MediumType {
  mimeType: string
  urls?: PhotoURL
}

export const noImageSrc = '/img/no-img.jpeg'

export const galleryMimeTypes = [
  'image/jpeg', 'image/png', 'image/gif', 'image/webp',
  'video/mp4',
]

export const imageMimeTypes = [
  'image/webp',
  'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/pipeg', 'image/tiff',
]

export const imageExtensions = [
  '.webp',
  '.jpeg', '.jpg', '.png', '.gif', '.pipeg', '.tiff',
]

export const extToMimeType: Record<string, string> = {
  '.webp': 'image/webp',
  '.jpeg': 'image/jpeg',
  '.jpg': 'image/jpeg',
  '.png': 'image/png',
  '.gif': 'image/gif',
  '.pipeg': 'image/pipeg',
  '.tiff': 'image/tiff',
}

export const videoMimeTypes = [
  'video/x-flv',
  'video/mp4',
  'application/x-mpegURL',
  'video/MP2T',
  'video/3gpp',
  'video/quicktime',
  'video/x-msvideo',
  'video/x-ms-wmv',
]

export const isImage = (mimeType: string, filePath?: string): boolean => {
  if (mimeType) {
    return imageMimeTypes.includes(mimeType)
  }
  for (let c = 0; c < imageExtensions.length; c++) {
    if (filePath && filePath.endsWith(imageExtensions[c])) {
      return true
    }
  }
  return false
}

export const isVideo = (mimeType: string): boolean => {
  return videoMimeTypes.includes(mimeType)
}

/**
 * get srcsets - if no sizes found, return original src
 * @param urls
 * @param sizes array width sizes
 */
export const imageSrcset = (urls?: PhotoURL, sizes?: number[]): string => {
  if (!urls) {
    return ''
  }
  const genSizes = sizes || thumbSizes
  // console.log('urls', genSizes, urls)
  const foundURLS = genSizes.filter(s => !!urls[`t${s}`])
  if (foundURLS.length < 1) {
    return urls.original as string
  }

  const res = foundURLS
    .map((s) => {
      return `${urls[`t${s}`]} ${s}w`
    })
    .join(', ')
  // console.log('foundurls', res)
  return res
}

export const mediumFirstSrcset = (
  mediums: MediumType[] | undefined | null,
  sizes?: number[],
  noImage?: string,
): string => {
  if (typeof mediums === 'undefined' || mediums === null) {
    return noImage || noImageSrc
  }

  let first = mediums.find(m => isImage(m.mimeType) && m.urls)
  if (first) {
    return imageSrcset(first.urls as PhotoURL, sizes)
  }
  return noImage || noImageSrc
}
export const getImageMimeType = (
  fileName: string,
  defaultMime = 'image/jpeg',
): string | null => {
  const ext = fileName.split('.').pop()?.toLocaleLowerCase()

  if (ext) {
    return extToMimeType[`.${ext}`] || defaultMime
  }
  return null
}
